export enum LabelsManagerWorkingMode {
    NORMAL_STATE = 0,
    REMOVE_STATE = 1,
    EDIT_STATE = 2,
    ADD_STATE = 3
  }
  